import {
	Navigate,
	Outlet,
	Route,
	createBrowserRouter,
	createRoutesFromElements,
} from "react-router-dom";
import Layaut from "./layaut";
import NetworkPlatforms from "./network/NetworkPlatforms";
import NetworkView from "./network/NetworkView";
import Home from "./home/Home";
import Development from "./development/Development";
import Analize from "./analize/Analize";
import Coins from "./analize/Coins";
import Scanner from "./scanner/Scanner";
import ChainConfigView from "./network/ChainConfigView";
import MerchantWallets from "./merchantWallets/MerchantWallets";
import WalletInfo from "./walletInfo/WalletInfo";
import Login from "./login/Login";
import Logout from "./logout/Logout";
import Configs from "./configs/Configs";
import PageSpinner from "../componets/PageSpinner";
import Notifications from "./notifications/Notifications";
import Transaction from "./transaction/Transaction";
import SystemWallets from "./systemWallets/SystemWallets";

//import Transaction from "./transaction/Transaction";
// import ConnectWallet from "./transaction/ConnectWallet";

const router = token => {
	if (!token) {
		return createBrowserRouter(
			createRoutesFromElements(
				<Route
					path="/"
					element={
						<>
							<PageSpinner />
							<Outlet />
						</>
					}>
					<Route index element={<Navigate to="/login" replace />} />
					<Route path="login" element={<Login />} />
					{/* <Route path="/logout" element={<Logout />} /> */}
					<Route path="*" element={<Navigate to="/login" replace />} />
				</Route>,
			),
		);
	}
	return createBrowserRouter(
		createRoutesFromElements(
			<Route path="/" element={<Layaut />}>
				<Route index={true} element={<Home />} />
				<Route
					path="network-platforms"
					element={<NetworkPlatforms />}
					loader={NetworkPlatforms.loader}
				/>
				<Route path="network-platform-view" element={<NetworkView />} />
				<Route path="network-development" element={<Development />} />
				<Route path="network-analyze" element={<Analize />} />
				<Route
					path="chain-config-view/:chainId"
					element={<ChainConfigView />}
					loader={ChainConfigView.loader}
				/>
				<Route path="coins" element={<Coins />} />
				<Route path="scanner" element={<Scanner />} />
				<Route
					path="merchant-wallets"
					element={<MerchantWallets />}
					loader={MerchantWallets.loader}
				/>
				<Route
					path="wallet-info/:walletId"
					element={<WalletInfo />}
					loader={WalletInfo.loader}
				/>

				<Route
					path="transaction"
					element={<Transaction />}
					loader={Transaction.loader}
				/>
				<Route path="system-wallets" element={<SystemWallets />} />
				<Route
					path="network-platform-view/:networkId"
					element={<NetworkView />}
					loader={NetworkView.loader}
				/>
				<Route
					path="network-platform-view/:networkId"
					element={<NetworkView />}
					loader={NetworkView.loader}
				/>
				<Route
					path="notifications"
					element={<Notifications />}
					loader={Notifications.loader}
				/>
				<Route path="/configs" element={<Configs />} loader={Configs.loader} />
				<Route path="/logout" element={<Logout />} />
			</Route>,
		),
	);
};

export default router;
